
import { useContentsStore } from "@/stores/contents"
import { defineStore } from "pinia"
import { ref } from 'vue'

export const useWorkerStore = defineStore('worker', () => {
  const contentsStore = useContentsStore()
  const worker = ref<Worker | null>(null)

  const initializeWorker = (newWorker: Worker) => {
    worker.value = newWorker
    worker.value.onmessage = (e) => {
      contentsStore.dispatch.onReceiveWorkerMessage(e.data)
    }
  } 
  const backgroundTask = (args: {messages: Array<any>}) => { 
    if(!worker.value) return;
    args.messages.forEach(message => {
      worker.value?.postMessage(JSON.stringify(message))
    });
  }

  const setContentsStorageWorker = (worker: Worker) => {
    contentsStore.dispatch.setContentsStorageWorker(worker);
  }

  const stopWorkerJobs = () => {
    contentsStore.dispatch.stopWorkerJobs();
  }

  return {
    initializeWorker,
    backgroundTask,
    setContentsStorageWorker,
    stopWorkerJobs,
  }
})
